const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserprofileicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.667
    },
    fill: "#fefffe",
    d: "M 8.5,2.5 C 15.1584,1.34448 17.1584,3.84448 14.5,10C 7.74962,11.4689 5.74962,8.9689 8.5,2.5 Z M 10.5,5.5 C 12.337,5.63945 12.6704,6.30612 11.5,7.5C 10.7025,7.04311 10.3691,6.37644 10.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.765
    },
    fill: "#fefffe",
    d: "M 5.5,13.5 C 9.51383,13.3345 13.5138,13.5012 17.5,14C 20.1446,15.2865 21.1446,17.4532 20.5,20.5C 14.5,20.5 8.5,20.5 2.5,20.5C 1.90934,17.3247 2.90934,14.9913 5.5,13.5 Z M 7.5,16.5 C 10.9783,16.1842 14.3117,16.6842 17.5,18C 13.5,18.6667 9.5,18.6667 5.5,18C 6.4158,17.7216 7.08247,17.2216 7.5,16.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserprofileicon);
export default __webpack_public_path__ + "static/media/userprofileicon.a5659586242d631d3f7917e18b07d517.svg";
export { ForwardRef as ReactComponent };